import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SA_LANGUAGES, SupportedLanguage } from '../../services/language.service';

@Component({
  selector: 'app-language-picker-modal',
  templateUrl: './language-picker-modal.component.html',
  styleUrls: ['./language-picker-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, FormsModule, TranslateModule]
})
export class LanguagePickerModalComponent {

  /** The currently active language code, shown with a checkmark. */
  @Input() selectedCode: string = 'en';

  searchQuery = '';
  readonly languages: SupportedLanguage[] = SA_LANGUAGES;

  constructor(private modalController: ModalController) {}

  get filtered(): SupportedLanguage[] {
    const q = this.searchQuery.toLowerCase().trim();
    if (!q) return this.languages;
    return this.languages.filter(l =>
      l.label.toLowerCase().includes(q) ||
      l.nativeLabel.toLowerCase().includes(q)
    );
  }

  select(lang: SupportedLanguage): void {
    this.modalController.dismiss({ code: lang.code });
  }

  dismiss(): void {
    this.modalController.dismiss(null);
  }
}
